import React from 'react';
import { WorkspaceHero } from '../components/WorkspaceHero';
import { NovaSection } from '../components/nova/NovaSection';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
// Exploration variant of the home page. Identical to Home, but the hero is
// reimagined as an animated Slack/Teams workspace where colleagues @mention
// Giga and Giga replies with finished work — a place to explore the
// "chat box as a real workspace" direction.
export function WorkspaceHome() {
  return <>
      <WorkspaceHero data-id="element-5944" />
      <NovaSection data-id="element-5945" />
      <AudienceSwitch data-id="element-5946" />
      <LivesInSlack data-id="element-5947" />
      <ComputerUse data-id="element-5948" />
      <CapabilityGrid data-id="element-5949" />
      <NarrativeSection data-id="element-5950" />
      <WallOfLove data-id="element-5951" />
      <GettingStartedSteps data-id="element-5952" />
      <PricingSection data-id="element-5953" />
      <ClosingCTA data-id="element-5954" />
    </>;
}